interface PlaceholderType {
  [key: string]: string
}

const createPlaceholderImage = (w: number, h: number): string => {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${w} ${h}'%3E%3C/svg%3E`
}

export const SVG_PLACEHOLDER_IMAGES: PlaceholderType = {
  SQUARE: createPlaceholderImage(1000, 1000),
  SQUARE_CARD: createPlaceholderImage(196, 196),
  CATEGORY_HERO_IMAGE: createPlaceholderImage(1768, 484),
  CATEGORY_BANNER: createPlaceholderImage(656, 190),
  TOP_NEW_ARTICLE: createPlaceholderImage(504, 276),
  TOP_CAROUSEL: createPlaceholderImage(1720, 560),
  MAGAZINE_CARD: createPlaceholderImage(306, 122)
}
